import { useMemo } from 'react'
import { useCareerInsightsData } from 'builder/hooks/useCareerInsightsData'

export const useCoverLetterTextParts = () => {
  const { careerInsightsData } = useCareerInsightsData()
  const results = careerInsightsData?.coverLetterResults

  return useMemo(() => {
    if (!results) {
      return []
    }
    return [results.introduction, results.pitch, results.results, results.close]
  }, [results])
}
